module.exports = __webpack_public_path__ + "static/media/health.ca264206.png";